import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { Chart3dContextProvider } from 'lib/context/Chart3dContext/Chart3dContextProvider';
import { ClinicalNoteContextProvider } from 'lib/context/ClinicalNoteContext/ClinicalNoteContextProvider';
import { AmbientListeningContextProvider } from 'lib/context/MyScribeAI/AmbientListeningContext/AmbientListeningContextProvider';
import { MyScribeAIContextProvider } from 'lib/context/MyScribeAI/MyScribeAIContextProvider';
import { useClinicalNote } from 'lib/hooks/queries/clinicalNotes/useClinicalNotes';

import { currentPractice } from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import { defaultColumns as columns, getPracticeDefaultFilters } from '../lib/helper';

import CreateClinicalNoteButton from './CreateClinicalNoteButton';

const ClinicalNotesTable = ({ patientId }) => {
  const navigate = useNavigate();
  const practice = useRecoilValue(currentPractice);

  const onCellClicked = async (e) => {
    if (e?.column?.getColId() === 'actions' || e?.column?.getColId() === 'checkbox') return;
    if (['actions', '0'].includes(e?.column?.colId) || e?.column?.colId === '1') return;

    navigate(
      `/portal/charts/${e?.data?.appointment.user_id ?? e?.appointment?.user_id}/clinical-notes/${
        e?.data?.appointment.id ?? e?.appointment?.id
      }`
    );
  };

  const defaultFilters = useMemo(() => getPracticeDefaultFilters(), []);

  const columnDefs = useMemo(() => columns(practice?.timezone), [practice?.timezone]);

  return (
    <ClinicalNoteContextProvider outsideClinicalNoteContext={true}>
      <Chart3dContextProvider>
        <MyScribeAIContextProvider>
          <AmbientListeningContextProvider>
            <AgTablePage
              defaultColumns={columnDefs}
              defaultFilters={defaultFilters}
              queryOptions={{
                refetchOnMount: true,
                staleTime: 5000
              }}
              useData={useClinicalNote}
              name="patient_clinical_notes"
              queryKey="clinicalNote"
              title="Patient Clinical Notes"
              rowStyle={{ cursor: 'pointer' }}
              rightHeaderActions={() => <CreateClinicalNoteButton patientId={patientId} />}
              onSelectRow={onCellClicked}
              queryParams={{
                patientId,
                pagination: true,
                withDocumentSign: true,
                withPatient: true
              }}
            />
          </AmbientListeningContextProvider>
        </MyScribeAIContextProvider>
      </Chart3dContextProvider>
    </ClinicalNoteContextProvider>
  );
};

export default ClinicalNotesTable;
